import React from "react";
import { useCosmeticConsultationFlow } from "hooks/useConsultationFlow";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import VisitSummaryContent from "components/visitSummaryAccordion/VisitSummaryContent";
import { cosmeticConsultationReducers } from "reducers/cosmetic/cosmeticConsultationReducer";
import { cosmetic_steps } from "helpers/enum";
import VisitSummaryContentHeading from "components/visitSummaryAccordion/VisitSummaryContentHeading";
import VisitSummaryContentParagraph from "components/visitSummaryAccordion/VisitSummaryContentParagraph";

function CosmeticAdditionalDetailsSummary({ data, readOnly }) {
  const { incompleteData } = useCosmeticConsultationFlow();
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <VisitSummaryContent
      readOnly={readOnly}
      onEditClick={() => {
        dispatch(
          cosmeticConsultationReducers.currentScreen({
            value: cosmetic_steps.previous_treatment,
          })
        );
        history.push("/consultation/cosmetic");
      }}
    >
      <VisitSummaryContentHeading text="Previous Treatment Feedback" />
      <VisitSummaryContentParagraph
        text={
          data?.previous_diagnosis?.length
            ? data?.previous_diagnosis
            : incompleteData?.previous_diagnosis?.length
            ? incompleteData?.previous_diagnosis
            : "No"
        }
      />
    </VisitSummaryContent>
  );
}

export default CosmeticAdditionalDetailsSummary;
